<app-header text='default'></app-header>

<div id="readspeaker_button_1" class="rs_skip rsbtn rs_preserve" *ngIf="env.readspeaker.enabled">
  <a rel="nofollow" class="rsbtn_play" accesskey="L" i18n-title="@@readSpeakerDescription" title="Listen to this page using ReadSpeaker webReader" [attr.href]="getReadSpeakerURL('content')">
      <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span i18n="@@readSpeakerListen">Listen</span></span></span>
      <span class="rsbtn_right rsimg rsplay rspart"></span>
  </a>
</div>

<div id="back-container">
  <div id="content">
    <!--<div class="subtitle">{{ SUBTITLE }}</div>-->
    <div id="acknowledgement">
      <app-media [resource]=currentResource></app-media>
      <!--<img class="avatar-msg" src="/static/images/orientation.svg" alt=""/>-->
      <div class="avatar-msg-text">
        <div class="text">
          <b i18n="">Well Done! Skills check complete!</b> 
          <br/>
          <div class="text" i18n="">You're on your way to achieving your goal to:</div>
        </div>
        <div class="text interest"><b>{{interest.text}}</b></div>
        <div class="text" i18n="@@balloonDescription">
          The balloons will give you an idea of your skill level. The bigger the balloon the stronger your skill in that area is!
        </div>
      </div>
    </div>
    <div id="result">
      
      <div class="row" [style.background-image]="'url(' + commonService.getImagePath('background-results.svg')+ ')'">
        
        <div class="col-7 results">
          <div class="heading">
        <img [src]="getPath('arrows.png')" alt="arrows">
        <span  i18n="">What's next?</span>
      </div>
          <!--<div *ngIf='!!texts.resultsText' class="text d-flex flex-row h-100">-->
            <div *ngIf='!!texts.resultsText' class="text h-100">
            <div class="align-self-center">
              <!--<b>Well done! </b>{{ texts.resultsText }}-->
              <div class="message container text" i18n="">Improve your skills so you can take the next step towards achieving your goal by:</div>
              <ul>
              <li class="message container text" *ngFor='let text of texts.learningPathwayDescription'>
                {{ text }}
              </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div class="col-5 ballons">
          <img [src]="resultsImage" alt=" ">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="message container text" *ngIf="getCourses('brush_up').length > 0 || getCourses('develop').length > 0" >
                <span  i18n="">Check out your <b>Learning Pathway</b> and find a course that's right for you:</span>
            </div>
        </div>
        <div class="col-5">
          <div class="localization" *ngIf="getCourses('brush_up').length > 0 || getCourses('develop').length > 0">
        <!--<div class="heading">Learning opportunities in your area</div>-->
        <button type="button" mdbBtn class="button special" mdbWavesEffect (click)="chooseArea()">
          <i class="fas fa-map-marker-alt"></i><span i18n="">My Learning Pathway</span>
        </button>
      </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="message container text" i18n="">
                Click the <b>Download My Skill Summary</b> button for a full summary of your CITO Skills Checker journey:
            </div>
        </div>
        <div class="col-5">
          <button type="button" mdbBtn class="button special" mdbWavesEffect (click)="saveResults()">
            <span i18n="">Download My Skill Summary</span>
          </button>
        </div>
      </div>
    </div>
    
    <!--<div class="holder"></div>-->
    <div id="pathway" *ngIf="getCourses('brush_up').length > 0 || getCourses('develop').length > 0">
      <!--
      <div class="intro">
        <div class="heading">
          <img [src]="getPath('arrows.png')" alt="arrows">
          {{ LEARNING_PATHWAY_HEADER }}
        </div>
      </div>
    -->
      <!--
      <div class="learning-oportunities" *ngIf="getCourses('brush_up').length > 0 || getCourses('develop').length > 0">
        <div class="brush-up" *ngIf="getCourses('brush_up').length > 0">
          <div class="heading">Brush up</div>
          <app-course
            *ngFor="let course of getCourses('brush_up')"
            [course]=course
            colour='green'
            from='results'
            [results]='results'
            class="course"
          ></app-course>
        </div>
        <div class="develop" *ngIf="getCourses('develop').length > 0">
          <div class="heading">Further develop</div>
          <app-course
            *ngFor="let course of getCourses('develop')"
            [course]=course
            colour='blue'
            from='results'
            [results]='results'
            class="course"
          ></app-course>
        </div>
      </div>
      -->

      
    </div>
  </div>
</div>
<div class="footer">
  <app-navigate-button i18n-text text="New goal" (event)="selectNewInterest()"></app-navigate-button>
</div>